module.exports = __webpack_public_path__ + "static/media/Add.d0f5911d.svg";